<style >
    /* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .7s ease;
}
.slide-fade-leave-active {
  transition: all .8s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>

<template>
 <div>

    <transition name="slide-fade">

        <v-stepper v-model="step" vertical >

            <!-- PASO 1 -->
            <v-stepper-step :complete="form_data.step > 1" step="1">
                Algunos datos básicos sobre tu nuevo ensayo
                <!-- <small> </small> -->
            </v-stepper-step>

            <v-stepper-content step="1">

                <formInformation ref="formInfoEns"></formInformation>
                <v-btn color="primary" @click="step1()">Continue</v-btn>

            </v-stepper-content>
            <!-- FIN PASO 1 -->

            <!-- PASO 2 -->
            <v-stepper-step :complete="form_data.step > 2" step="2">
                Detalle de la técnica
                <!-- <small> Agrega o remueve matrices </small> -->
            </v-stepper-step>

            <v-stepper-content step="2">
                <formDetalle />

                <v-btn color="primary" @click="step2()">Guardar</v-btn>
                <v-btn text @click="setStep(1)">Atrás</v-btn>
            </v-stepper-content>
            <!-- FIN PASO 2 -->

            <!-- PASO 3 -->
            <v-stepper-step :complete="form_data.step > 3" step="3">
                Matrices y umbrales
                <!-- <small> Agrega o desactiva patogenos de este ensayo </small> -->
            </v-stepper-step>

            <v-stepper-content step="3">
                <formUmbrales/>

                <v-btn color="succes" @click="step3()">Guardar</v-btn>
                <v-btn text @click="setStep(2)">Atrás</v-btn>
            </v-stepper-content>
            <!-- FIN PASO 3 -->

            <!-- OVERLAY -->
            <v-overlay z-index="7" :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

        </v-stepper>
    </transition>

        <v-snackbar
        v-model="error.error"
        :timeout="2000"
        >
        {{ error.txt }}
        <v-btn
            color="red"
            text
            @click="error.error = false"
        >
            Cerrar
        </v-btn>
        </v-snackbar>

        <v-snackbar
        v-model="snack.activo"
        :timeout="2000"
        :top="true"
        >
        {{ snack.txt }}
        <v-btn
            :color="snack.color"
            text
            @click="snack.activo = false"
        >
            Cerrar
        </v-btn>
        </v-snackbar>

 </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Ensayos',
  components: {
    formInformation: () => import('./Ensayos/Informacion'),
    formDetalle: () => import('./Ensayos/Detalle'),
    formUmbrales: () => import('./Ensayos/Umbrales'),
  },
  computed: {
    ...mapState('Ensayos', ['data_ensayo', 'bool_form_steps', 'form_data']),
    step() {
      // if (!this.form_data.data_ensayo_valid) {
      //   this.setFormStep(true, 1);
      // }
      return this.form_data.step;
    },
  },
  created() {
    // const data_ensayo = this.form_data.data_ensayo;
    console.log('form_data-stepEnsayos2 ', this);
    // this.form_data.data_ensayo.valid = false;
  },
  data() {
    return {
      show: false,
      error: {
        error: false,
        txt: null,
      },
      snack: {
        activo: false, txt: null, color: 'red', error: false,
      },
      response: null,
      selected: [],
      overlay: false,
    };
  },
  methods: {
    ...mapMutations('Ensayos', ['setValidDataEnsayo', 'setFormStep', 'setStep', 'clearAllDataForm']),
    step1() {
      this.setValidDataEnsayo(this.$refs.formInfoEns.validate());
      if (this.form_data.data_ensayo_valid) {
        this.setStep(2);
      }
    },
    step2() {
      this.setStep(3);
    },
    async step3() {
      // VALIDAMOS EL PASO 3
      // QUE HAYA PATOGENOS
      if (this.form_data.patogenos_selected.length <= 0) {
        this.snack.error = true;
        this.snack.activo = true;
        this.snack.color = 'red';
        this.snack.txt = 'Ingrese un patógeno';
        return;
      }
      // QUE CADA PATOGENO TENGA SUS TECNICAS EN CADA MATRIZ SELECCIONADA
      const error = { error: false, matriz: [] };
      this.form_data.patogenos_selected.map((pat) => {
        this.form_data.data_matrices.map((matriz) => {
          let found = false;
          this.form_data.data_tecnicas.map((tech) => {
            if (tech.matriz === matriz.id && tech.pat === pat.cod_pat) { found = true; }
            return true;
          });
          if (!found) { error.error = true; error.matriz.push(matriz); }
          return true;
        });
        return true;
      });

      if (error.error) {
        this.snack.error = true;
        this.snack.activo = true;
        this.snack.color = 'red';
        this.snack.txt = 'Faltan Técnicas';
        return;
      }
      console.log('validacion step3 : ', [this.form_data, error]);

      //  SI NO OBTIENE NINGUN ERROR REINICIA EL FORMULARIO
      if (!await this.finalizar()) {
        this.setFormStep(false);
        this.clearAllDataForm();
        this.snack.error = false;
        this.snack.activo = true;
        this.snack.color = 'green';
        this.snack.txt = 'Ensayo guardado correctamente';
      }
    },
    async finalizar() {
      const E = false; // error
      this.overlay = true;
      // const url = (this.form_data.data_ensayo.id) ?
      // '/stepEnsayos/updateEnsayo' : '/stepEnsayos/createEnsayo';

      // await axios.post(url, this.form_data)
      //   .then((response) => {
      //     console.log('finalizar : ', response);
      //   })
      //   .catch((error) => {
      //     E = true;
      //     console.log('error al finalizar : ', error);
      //   });
      // window.location.href = '/';
      this.overlay = false;

      return E;
    },
  },
};
</script>
